import * as React from "react";
import type { SVGProps } from "react";
import PropTypes from 'prop-types';
/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string;
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number;
  alt?: string;
}
function IconUploadDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M6.77 8.843a1.11 1.11 0 0 0 1.571 0L12 5.183l3.659 3.66A1.111 1.111 0 1 0 17.23 7.27l-4.444-4.444a1.11 1.11 0 0 0-1.572 0L6.77 7.27a1.11 1.11 0 0 0 0 1.572" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M12 16.945c.613 0 1.11-.497 1.11-1.11V4.167a1.111 1.111 0 0 0-2.221 0v11.666c0 .614.497 1.111 1.11 1.111" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M3.111 16.945c.614 0 1.111.498 1.111 1.111v1.111c0 .614.498 1.112 1.111 1.112h13.334c.613 0 1.11-.498 1.11-1.111v-1.112a1.111 1.111 0 1 1 2.223 0v1.111a3.333 3.333 0 0 1-3.333 3.334H5.333A3.333 3.333 0 0 1 2 19.167v-1.11c0-.614.497-1.112 1.111-1.112" clipRule="evenodd" /></svg></>;
}
IconUploadDefault.propTypes = ({
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string
} as PropTypes.ValidationMap<Props>);
export default IconUploadDefault;